module.exports = __webpack_public_path__ + "img/img_engineering_img2.38f02f66.png";